<template>

    <div class="badge-sash">
        <div>
            <b-badge v-b-tooltip.hover :title="!printQueueCount || showLabels ? '' : printQueueName"
                :to="routerLink(storeId, programId, 'print')" :class="(!printQueueCount ? 'empty' : '')"
                variant="primary">
                {{ printQueueCount ? printQueueCount : "" }}
                <Transition name="fade">
                    <div v-if="showLabels && printQueueCount">
                        <small>Queue</small>
                    </div>
                </Transition>
            </b-badge>
        </div>
        <div>
            <b-badge v-b-tooltip.hover :title="!staleQueueCount || showLabels ? '' : stalePrintQueueName"
                :to="routerLink(storeId, programId, 'stale')" :class="(!staleQueueCount ? 'empty' : '')" variant="info">
                {{ staleQueueCount ? staleQueueCount : "" }}
                <Transition name="fade">
                    <div v-if="showLabels && staleQueueCount">
                        <small>Stale</small>
                    </div>
                </Transition>
            </b-badge>
        </div>
        <div>
            <b-badge v-b-tooltip.hover :title="!outOfStockCount ? '' : 'Out Of Stock'"
                :to="routerLink(storeId, programId, 'print', true)" :class="(!outOfStockCount ? 'empty' : '')"
                variant="danger">
                {{ outOfStockCount ? outOfStockCount : "" }}
                <Transition name="fade">
                    <div v-if="showLabels && outOfStockCount">
                        <small>OOS</small>
                    </div>
                </Transition>
            </b-badge>
        </div>
    </div>

</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';

@Component({
    name: "PrintQueueTableBadges"
})
export default class PrintQueueTableBadges extends Vue {
    @Prop({ default: null }) protected storeId!: number | string | null;
    @Prop({ default: null }) protected programId!: number | null;
    @Prop() protected counts?: {
        printQueueCount: number,
        stalePrintQueueCount: number,
        outOfStockCount: number
    };
    @Prop({ default: false }) protected showLabels!: boolean;
    @Prop({default: false}) protected consignment!: boolean;

    get printQueueCount() {
        return this.counts?.printQueueCount;
    }

    get staleQueueCount() {
        return this.counts?.stalePrintQueueCount;
    }

    get outOfStockCount() {
        return this.counts?.outOfStockCount;
    }

    get printQueueName() {
        return this.$pageNames?.printQueue ?? "Print Queue";
    }

    get stalePrintQueueName() {
        return this.$pageNames?.stalePrintQueue ?? "Stale Print Queue";
    }

    routerLink(storeId: any, programId: any, kind: string, oos = false): Route {
        return {
            name: kind == "stale" ? "StalePrintQueue" : "PrintQueue",
            query: {
                storeId,
                programId,
                oos: oos,
                consignment: this.consignment
            }
        } as unknown as Route;
    }
}

</script>

<style scoped>
.badge-sash {
    display: flex;
    gap: 5px;
    font-variant-numeric: tabular-nums;
    font-size: 1.25em;

    >* {
        width: 50px;
        text-align: center;
    }

    .empty {
        opacity: .2;
    }

    .badge {
        margin-bottom: 0;
        line-height: .95;
        width: 100%;
    }

    small {
        font-weight: 400;
        font-size: .7em;
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .2s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
